import React, { useState, useEffect, forwardRef } from 'react';
import styles from './PatientDetailDropdownCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PatientDetailDropdownCard = forwardRef((props, ref) => {

    const {
        title,
        subtitle,
        subtitle2,
        subtitle3,
        notePreview,
        label,
        icon,
        cardInfo,
        onFirstOpen,
        isOpen,
        rightComponent,
        headerBackground = "white",
        width = '740px'
    } = props;

    const [openCardToggle, setOpenCardToggle] = useState(false);
    const [hasOpened, setHasOpened] = useState(false);

    // Automatically open the card based on the isOpen prop from the parent
    useEffect(() => {
        if (isOpen) {
            setOpenCardToggle(true);
        }
    }, [isOpen]);

    const toggleCardOpen = () => {
        setOpenCardToggle(!openCardToggle);
        if (!hasOpened && onFirstOpen) {
            onFirstOpen();
            setHasOpened(true);
        }
    };

    return (
        <div className={styles.DropdownContainer} ref={ref} style={{width: width}}>
            <div style={{background: headerBackground}} className={openCardToggle ? styles.OpenPatientCard : styles.ClosedPatientCard}>
                <div className={styles.Header} onClick={toggleCardOpen}>
                    <div className={styles.HeaderLeft}>
                        <div>
                            {openCardToggle ? (
                                <FontAwesomeIcon icon="fa-solid fa-angle-down" />
                            ) : (
                                <FontAwesomeIcon icon="fa-solid fa-angle-right" />
                            )}
                        </div>
                        {icon}
                        <span className={styles.CardTitle}>{decodeURIComponent(title)}</span>
                        {subtitle && (
                            <span style={{fontWeight: "500"}} className={styles.BorderLeftLabel}>{subtitle}</span>
                        )}
                        {subtitle2 && (
                            <span className={styles.BorderLeftLabel}>{subtitle2}</span>
                        )}
                        {subtitle3 && (
                            <span className={styles.BorderLeftLabel}>{subtitle3}</span>
                        )}
                    </div>
                    <div className={styles.HeaderRight}>
                        {label && (
                            <div className={styles.CardTag} style={{ backgroundColor: `${label.color}` }}>
                                {label.name}
                            </div>
                        )}
                        {rightComponent && (
                            <div className={styles.RightComponent}>
                                {rightComponent}
                            </div>
                        )}
                    </div>
                </div>
                {notePreview && !openCardToggle && (
                    
                    <span style={{fontSize:"13px"}} dangerouslySetInnerHTML={{ __html: notePreview.length > 100 ? notePreview.substring(0, 100) : notePreview}}/>
                )}
            </div>
            <div className={styles.PatientCardBody} hidden={!openCardToggle}>
                {cardInfo}
            </div>
        </div>
    );
});

export default PatientDetailDropdownCard;
